var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 60,
    viewBox: "0 0 74 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 0H6.66667C3 0 0 3 0 6.66667V46.6667C0 50.3333 3 53.3333 6.66667 53.3333H23.3333V60H50V53.3333H66.6667C70.3333 53.3333 73.3 50.3333 73.3 46.6667L73.3333 6.66667C73.3333 3 70.3333 0 66.6667 0ZM66.6667 46.6667H6.66667V6.66667H66.6667V46.6667Z",
    fill: "#2E3192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTv);
export default __webpack_public_path__ + "static/media/ic_tv.648930614651fb44220e32545a9246f1.svg";
export { ForwardRef as ReactComponent };